import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';
import api from '../api';

export default function BookRegistration() {
    const [name, setName] = useState('');
    const [image, setImage] = useState(null);
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [books, setBooks] = useState([]);

    const fetchBooks = async () => {
        try {
            const { data } = await api.get('/books/');
            setBooks(data);
        } catch (err) {
            console.error("Failed to fetch books", err);
        }
    };

    useEffect(() => {
        fetchBooks();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage('');
        setError('');

        const formData = new FormData();
        formData.append('name', name);
        if (image) {
            formData.append('image', image);
        }

        try {
            await api.post('/books/', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            setMessage('책이 성공적으로 등록되었습니다.');
            setName('');
            setImage(null);
            e.target.reset(); // Clear file input
            fetchBooks(); // Refresh the book list
        } catch (err) {
            setError('등록에 실패했습니다. 입력 내용을 확인해주세요.');
            console.error(err);
        }
    };

    const handleDelete = async (bookId) => {
        if (window.confirm('정말로 이 책을 삭제하시겠습니까? 관련된 모든 독서 기록도 삭제될 수 있습니다.')) {
            try {
                await api.delete(`/books/${bookId}/`);
                fetchBooks(); // Easiest way to refetch the list
            } catch (err) {
                alert('책 삭제에 실패했습니다.');
                console.error(err);
            }
        }
    };

    return (
        <Layout>
            <Link to="/teacher" className="back-link">선생님 홈으로</Link>
            <div style={{ maxWidth: '600px', margin: 'auto' }}>
                <h1>책 등록</h1>
                <form onSubmit={handleSubmit}>
                    <p>책 이름</p>
                    <input
                        type="text"
                        name="name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        required
                    />
                    <p>책 이미지</p>
                    <input
                        type="file"
                        name="image"
                        accept="image/*"
                        onChange={(e) => setImage(e.target.files[0])}
                    />
                    <button type="submit">등록</button>
                </form>
                {message && <p className="message success">{message}</p>}
                {error && <p className="message error">{error}</p>}

                <div className="book-list-container" style={{ marginTop: '40px' }}>
                    <h2>등록된 책 목록</h2>
                    <div className="log-container">
                        {books.map((book) => (
                            <div className="log-item" key={book.id}>
                                {book.image ? (
                                    <img src={book.image} alt={book.name} />
                                ) : (
                                    <div className="no-image-placeholder"><span>이미지 없음</span></div>
                                )}
                                <h3>{book.name}</h3>
                                <button onClick={() => handleDelete(book.id)} className="delete-button">삭제</button>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </Layout>
    );
}

